export default "__VITE_ASSET__DCsO5TWB__"